/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { UserResetPasswordVerifyRequest } from '../entities/UserResetPasswordVerifyRequest'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const userResetPasswordVerifyRequestSchema = z.object({
  code: z.string(),
  code_uuid: z.string(),
  password: z.string().min(8).max(64),
}) as unknown as ToZod<UserResetPasswordVerifyRequest>